import Vue from 'vue'

const ACCESS_TOKEN = process.env.TOKEN_HEADER

let isAddListener = false

const getFormatSiteDeviceFactor = (siteDeviceFactors, factorMap) => Object.freeze(siteDeviceFactors.filter(siteDeviceFactor => factorMap[siteDeviceFactor.factorId]).map(siteDeviceFactor => {
  let {factorId} = siteDeviceFactor
  let factor = factorMap[factorId]
  return Object.freeze({
    id: siteDeviceFactor.id,
    factorId,
    name: factor.name,
    parentId: factor.parentId,
    cas: factor.cas || '',
    isAlarm: siteDeviceFactor.isAlarm,
    allUnits: (factor.allUnits || '').split('|'),
    stdUnit: factor.stdUnit || '',
    displayUnit: factor.displayUnit || '',
    molecular: factor.molecular,
    decimalNum: factor.decimalNum,
    limitLow: siteDeviceFactor.limitLow,
    limitHigh: siteDeviceFactor.limitHigh,
    rootFactorId: factor.rootFactorId || '',
    status: factor.status
  })
}))

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem(ACCESS_TOKEN),
    id: 0,
    realName: null,
    isAdmin: false,
    permissions: [],
    auditAuth: 0,
    navList: [],
    orgId: null,
    orgTypeId: null,
    sites: [],
    siteDevices: [],
    showSideNav: true
  }),
  getters: {
    token: state => state.token,
    id: state => state.id,
    realName: state => state.realName,
    auditAuth: state => state.auditAuth,
    permissions: state => state.permissions,
    navList: state => state.navList,
    isAdmin: state => state.isAdmin,
    orgId: state => state.orgId,
    orgTypeId: state => state.orgTypeId,
    sites: state => state.sites,
    siteDevices (state, getters, storeState, storeGetters) {
      let deviceMap = storeGetters['Device/map']
      let factorMap = storeGetters['Factor/map']

      if (storeGetters['Factor/list'].length === 0) {
        return []
      }

      return Object.freeze(state.siteDevices.filter(siteDevice => deviceMap[siteDevice.deviceId]).map(siteDevice => {
        let {deviceId} = siteDevice
        let device = deviceMap[deviceId]

        return Object.freeze({
          id: siteDevice.id,
          siteId: siteDevice.siteId,
          deviceId,
          categoryId: siteDevice.deviceCategoryId,
          name: device.name,
          dataFrequency: siteDevice.dataFrequency,
          maxDelayTime: siteDevice.maxDelayTime,
          dataTimeTypeId: siteDevice.dataTimeTypeId,
          lowRange: siteDevice.lowRange,
          highRange: siteDevice.highRange,
          detectionHeights: Object.freeze(siteDevice.height ? siteDevice.height.split('|').map(height => Math.round(Number(height) * 1000)) : [0]),
          sn: siteDevice.sn,
          status: siteDevice.status,
          factorCategory: device.factorCategory,
          siteDeviceFactors: getFormatSiteDeviceFactor(siteDevice.siteDeviceFactors, factorMap),
          siteDeviceFactors0: getFormatSiteDeviceFactor(siteDevice.siteDeviceFactors0 || [], factorMap)
        })
      }))
    },
    showSideNav: state => state.showSideNav
  },
  mutations: {
    setAccountInfo (state, profile) {
      if (profile) {
        state.id = profile.id
        state.realName = profile.realName
        state.isAdmin = profile.isAdmin
        state.permissions = profile.permissions
        state.auditAuth = profile.auditAuth
        state.orgId = profile.orgId
        state.orgTypeId = profile.orgTypeId
      } else {
        state.id = 0
        state.realName = null
        state.permissions = []
        state.auditAuth = 0
        state.orgId = null
        state.orgTypeId = null
      }
    },
    setToken (state, token) {
      if (token) {
        localStorage.setItem(ACCESS_TOKEN, state.token = token)
      }
    },
    removeToken (state) {
      state.token = null
      localStorage.removeItem(ACCESS_TOKEN)
    },
    setNavList (state, navList) {
      let tmpMap = {}
      let tmpList = [...navList].sort((a, b) => a.routeIndex - b.routeIndex)
      let roots = []

      for (; tmpList.length > 0;) {
        let tmpNav = tmpList.shift()
        let name = tmpNav.name
        let parentName = tmpNav.parent
        let nav = {
          name,
          path: tmpNav.path,
          ...tmpNav.meta
        }
        let children = tmpNav.children

        if (Array.isArray(children) && children.length > 0) {
          nav.children = []
          tmpMap[name] = nav
          tmpList.push(...[...children].sort((a, b) => a.routeIndex - b.routeIndex))
        }

        if (parentName === null) {
          roots.push(nav)
        } else {
          tmpMap[parentName].children.push(nav)
        }
      }

      state.navList = Object.freeze(roots)
    },
    sites (state, sites) {
      sites.forEach(site => Object.freeze(site))
      state.sites = Object.freeze(sites)
    },
    siteDevices (state, siteDevices) {
      // siteDevices.forEach(siteDevice => {
      //   let {siteDeviceFactors} = siteDevice
      //
      //   if (Array.isArray(siteDeviceFactors)) {
      //     siteDeviceFactors.forEach(siteDeviceFactor => Object.freeze(siteDeviceFactor))
      //   }
      //
      //   Object.freeze(siteDevice)
      // })
      state.siteDevices = Object.freeze(siteDevices)
    },
    showSideNav (state, showSideNav) {
      state.showSideNav = showSideNav
    }
  },
  actions: {
    addListener ({commit}) {
      if (isAddListener) {
        return
      }

      isAddListener = true

      window.addEventListener('storage', event => {
        if (event.key === ACCESS_TOKEN) {
          let newValue = event.newValue

          if (newValue === null) {
            commit('removeToken')
          } else {
            commit('setToken', newValue)
          }
        }
      })
    },
    requestSiteInfos ({commit}) {
      return Promise.all([
        Vue.prototype.$api.Profile.getProfileSites(),
        Vue.prototype.$api.Profile.getProfileSiteDevices()
      ]).then(([sites, siteDevices]) => {
        commit('sites', sites)
        commit('siteDevices', siteDevices)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Profile.js